module.exports = __webpack_public_path__ + "img/PEF_logo@2x.0626aaa8.png";